"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
/**
 * @internal
 */
var MultiSelectListItem = /** @class */ (function (_super) {
    tslib_1.__extends(MultiSelectListItem, _super);
    function MultiSelectListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClassNames = function () {
            var _a;
            var _b = _this.props, title = _b.title, isSelected = _b.isSelected;
            return classnames_1.default((_a = {
                    "gd-list-item": true
                },
                _a["s-" + util_1.stringUtils.simplifyText(title)] = true,
                _a["has-only-visible"] = true,
                _a["is-selected"] = isSelected,
                _a));
        };
        _this.renderOnly = function () {
            var onOnly = _this.props.onOnly;
            return (react_1.default.createElement("span", { className: "gd-list-item-only", onClick: function (e) {
                    e.stopPropagation();
                    if (onOnly) {
                        onOnly();
                    }
                } },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.only" })));
        };
        return _this;
    }
    MultiSelectListItem.prototype.render = function () {
        var _a = this.props, title = _a.title, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, isSelected = _a.isSelected;
        return (react_1.default.createElement("div", { className: this.getClassNames(), onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
            react_1.default.createElement("label", { className: "input-checkbox-label" },
                react_1.default.createElement("input", { type: "checkbox", className: "input-checkbox", readOnly: true, checked: isSelected }),
                react_1.default.createElement("span", { className: "input-label-text" }, title)),
            this.renderOnly()));
    };
    return MultiSelectListItem;
}(react_1.PureComponent));
exports.MultiSelectListItem = MultiSelectListItem;
//# sourceMappingURL=MultiSelectListItem.js.map